import { BrandLogo } from '~/components/BrandLogo'

/**
 * En-tête de la barre latérale : le logo de l'organisation, ou à défaut le nom
 * de l'app, dans l'encre de la barre (#79).
 *
 * Le logo est posé à même la barre, peinte dans la primaire : une pastille de
 * fond le protégeait d'une primaire de même couleur, mais elle alourdissait
 * l'en-tête. C'est à l'organisation de fournir un logo qui se détache de sa
 * propre couleur — détouré, ou dans sa variante sombre.
 *
 * Masqué quand la barre est repliée en icônes : il n'y tiendrait pas.
 */
export function SidebarBrand() {
  return (
    <div className="flex h-20 items-center px-2 group-data-[collapsible=icon]:hidden">
      <BrandLogo
        surface="bar"
        className="h-16 w-auto max-w-full object-contain"
        fallbackClassName="truncate text-xl"
      />
    </div>
  )
}
